import { useEffect, useRef } from "react";

export default function GridCanvas({ className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let w = 0;
    let h = 0;
    const mouse = { x: 0.5, y: 0.5 };

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 768 ? 1.5 : 2);
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();

    const onMove = (e) => {
      mouse.x = e.clientX / window.innerWidth;
      mouse.y = e.clientY / window.innerHeight;
    };

    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      const step = Math.max(34, Math.min(w, h) / 24);
      const time = t * 0.00022;
      const mx = mouse.x - 0.5;
      const my = mouse.y - 0.5;
      ctx.strokeStyle = "rgba(240,238,228,0.075)";
      ctx.lineWidth = 1;

      for (let x = -step; x <= w + step; x += step) {
        ctx.beginPath();
        for (let y = 0; y <= h; y += 10) {
          const nx =
            x + Math.sin(y * 0.006 + time * 2 + x * 0.002) * 16 + mx * 14 * Math.sin(y * 0.004 + time);
          if (y === 0) ctx.moveTo(nx, y);
          else ctx.lineTo(nx, y);
        }
        ctx.stroke();
      }
      for (let y = -step; y <= h + step; y += step) {
        ctx.beginPath();
        for (let x = 0; x <= w; x += 10) {
          const ny =
            y + Math.sin(x * 0.006 + time * 1.6 + y * 0.002) * 16 + my * 14 * Math.sin(x * 0.004 + time);
          if (x === 0) ctx.moveTo(x, ny);
          else ctx.lineTo(x, ny);
        }
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    };

    const io = new IntersectionObserver(([entry]) => {
      cancelAnimationFrame(raf);
      if (entry.isIntersecting) raf = requestAnimationFrame(draw);
    });
    io.observe(canvas);

    window.addEventListener("resize", resize);
    window.addEventListener("pointermove", onMove);
    raf = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
      window.removeEventListener("resize", resize);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
}
